export default __webpack_public_path__ + "static/media/PH-C970.06975ca9.webp";